/**
 * The heading of one block of a dashboard or a page of several blocks (a
 * chart, a table, a group of tiles), on the canvas above the block's own
 * surface — the same place the page title sits, one step down the scale (h3).
 * Never an icon plate or a `CardHeader`: the block is named in words.
 */

import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export interface BlockHeadingProps {
  title: string;
  /** One quiet line: the period or the scope the block covers. */
  subtitle?: React.ReactNode;
  /** One control that belongs to the block as a whole, at the right. */
  action?: React.ReactNode;
  id?: string;
}

export const BlockHeading: React.FC<BlockHeadingProps> = ({ title, subtitle, action, id }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography id={id} variant="h3" component="h2">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: theme.custom.text.tertiary }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action}
    </Box>
  );
};

export default BlockHeading;
